"use client";

import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

const stepMessages = {
  starting: "Initializing payment...",
  approving: "🔐 Approving payment on server...",
  waiting_verification: "🔗 Verifying on the blockchain...",
  delivering_product: "📦 Delivering your product...",
  done: "🎉 Payment complete!",
  error: "❌ Something went wrong.",
};

const stepColors = {
  starting: "text-blue-500",
  approving: "text-yellow-500",
  waiting_verification: "text-purple-500",
  delivering_product: "text-green-500",
  done: "text-emerald-500",
  error: "text-red-500",
};

export default function PiPaymentModal({ step, onClose }) {
  const safeStep = typeof step === "string" ? step : null;

  return (
    <AnimatePresence>
      {safeStep && (
        <motion.div
          className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="bg-white dark:bg-neutral-900 rounded-2xl shadow-2xl p-6 w-full max-w-md relative"
            initial={{ scale: 0.9, y: 30 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.9, y: 30 }}
            transition={{ type: "spring", stiffness: 300, damping: 25 }}
          >
            <button
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
              onClick={onClose}
              aria-label="Close"
              type="button"
            >
              <X className="w-5 h-5" />
            </button>

            <div className="flex flex-col items-center justify-center space-y-4">
              <motion.div
                key={safeStep}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                className={`text-center text-xl font-medium ${
                  stepColors[safeStep] || ""
                }`}
              >
                {stepMessages[safeStep] || "Processing..."}
              </motion.div>

              <div className="w-full bg-gray-200 dark:bg-gray-700 h-2 rounded-full overflow-hidden">
                <motion.div
                  className="bg-primary h-full"
                  animate={{
                    width:
                      safeStep === "starting"
                        ? "10%"
                        : safeStep === "approving"
                        ? "35%"
                        : safeStep === "waiting_verification"
                        ? "60%"
                        : safeStep === "delivering_product"
                        ? "85%"
                        : "100%",
                  }}
                  transition={{ duration: 0.8 }}
                />
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
